import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import {
  GET_DT_PERFORMANCE,
  GET_DT_KEYIN_MAJOR_LOSS,
  GET_DT_KEYIN_MINOR_LOSS,
  SAVE_DT_KEYIN_MAJOR_LOSS,
  SAVE_DT_KEYIN_MINOR_LOSS,
  SAVE_DT_PERFORMANCE,
} from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import { Col ,FormGroup,} from "reactstrap";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";
import { getPermission } from "../../../../helpers/auth_helper";
import PropTypes from "prop-types";
import Select from "react-select";

const columnColor = [
  "rgb(126 142 218)",
  "rgb(100 120 215)",
  "rgb(85 110 230)",
  "rgb(67 98 248)",
];

function numberFormat(number, digit = 2) {
  if (number === null || number === "null" || number === "") return "";
  function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  if (isFloat(number)) return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
  return parseFloat(number).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
}

const formatPercentNumber = (cellContent, row) => {
  // console.log(cellContent);
  return (
    <div>
      {cellContent == null || cellContent == undefined || cellContent == "" ? "" : numberFormat(cellContent, 2) + " %"}
    </div>
  );
};

const formatNumber = (cellContent, row) => {
  // console.log(cellContent);
  return (
    <div>
      {numberFormat(cellContent, 2)}
    </div>
  );
};


function Performance(props) {
  const generateYearList = () => {
    const currentYear = new Date().getFullYear();
    let years = [];
    for (let index = currentYear - 4; index <= currentYear; index++) {
      years.push({ label: index, value: index });
    }
    return years;
  };
  const currentYear = new Date().getFullYear();
  const [listYear, setListYear] = useState(generateYearList());
  // DropDown Search
  const [yearSelected, setYearSelected] = useState({
    label: currentYear,
    value: currentYear,
  });
  const handleSelectedYear = selected => {
    setYearSelected(selected);
  };
  const dispatch = useDispatch();
  const permission = getPermission();
  const [modelDeviceList, setModelDeviceList] = useState([]);

  const [dataList, setDataList] = useState([]);

  const [listDataLossMajor, setListDataLossMajor] = useState([]);
  const [listDataLossMinor, setListDataLossMinor] = useState([]);

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = "white";

    return style;
  };

  const addHeaderTable = () => {
    let prevHeader = document.getElementById("performance");
    prevHeader && prevHeader.remove();
    let thead = document
      .getElementById("performance-tab-table")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '<th id="performance" colspan="' +
      5 +
      '" style="text-align:center;background-color:#556ee6;color:#FFFFFF">Performance</th>';
    thead.prepend(tr);
  };

  const addHeaderTableLossMajor = () => {
    let thead = document
      .getElementById("loss-major-tab-table")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '</th><th colspan="3" style="text-align:center;background-color:#6478D7;color:#FFFFFF">Gas Loss (รายใหญ่)</th>';
    thead.prepend(tr);
  };

  const addHeaderTableLossMinor = () => {
    let thead = document
      .getElementById("loss-minor-tab-table")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '</th><th colspan="3" style="text-align:center;background-color:#6478D7;color:#FFFFFF">Gas Loss (รายย่อย)</th>';
    thead.prepend(tr);
  };

  const generateRow = () => {
    function getDaysInMonth(year) {
      // console.log(year)
      let monthListPerformanceModel = [];
      let monthListGasLossMajor = [];
      let monthListGasLossMinor = [];
      for (let index = 0; index < 12; index++) {
        let date = new Date(year, index, 1);
        // console.log(date);
        monthListPerformanceModel.push({
          ...performanceModel,
          PERFORMANCE_YEAR: moment(date).format("YYYY-MM-DD"),
          month: moment(date).format("M"),
        });
        monthListGasLossMajor.push({
          ...lossMajorModel,
          MAJORLOSS_DATE: moment(date).format("YYYY-MM-DD"),
          MAJORLOSS_MONTH: moment(date).format("M"),
          month: moment(date).format("M"),
        });
        monthListGasLossMinor.push({
          ...lossMinorModel,
          MINORLOSS_DATE: moment(date).format("YYYY-MM-DD"),
          MINORLOSS_MONTH: moment(date).format("M"),
          month: moment(date).format("M"),
        });
      }

      return [
        monthListPerformanceModel,
        monthListGasLossMajor,
        monthListGasLossMinor,
      ];
    }

    let month;

    month = getDaysInMonth(yearSelected.value);
    // console.log(month);
    return month;



    //ของเก่า เป็นปี
    // function getDaysInMonth(year) {
    //   let currentYear = new Date().getFullYear();
    //   let yearList = [];
    //   for (let index = year; index <= currentYear; index++) {
    //     yearList.push({
    //       year: index,
    //       PERFORMANCE_YEAR: moment(new Date(index, 0, 1)).format("YYYY-MM-DD"),
    //     });
    //   }

    //   return yearList;
    // }

    // let dayList;
    // let startYear = 2021;
    // let tmp;
    // for (var i = dataList.length - 1; i >= 0; i--) {
    //   tmp = moment(dataList[i].PERFORMANCE_YEAR).format("YYYY");
    //   if (tmp < startYear) startYear = tmp;
    // }

    // dayList = getDaysInMonth(startYear);

    // dayList = addFieldToModelDeviceList(dayList);
    // setModelDeviceList(dayList);
    //ของเก่า เป็นปี
  };

  // const handleSaveData = async () => {
  //   dispatch(loadingAction.showLoading());
  //   try {
  //     let data = [...modelDeviceList];
  //     // console.log(data);
  //     let res = await post(SAVE_DT_PERFORMANCE, data);
  //     if (res.resultCode == 200) {
  //       dispatch(messageAction.showMessage("Save success."));
  //       fetchData();
  //     } else {
  //       dispatch(messageAction.showMessage(res.resultDescription));
  //     }
  //   } catch (error) {
  //     dispatch(messageAction.showMessage(error.message));
  //   }
  //   dispatch(loadingAction.hideLoading());
  // };

  const handleSaveData = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let [res1, res2, res3] = await Promise.all([
        post(SAVE_DT_PERFORMANCE, modelDeviceList),
        post(SAVE_DT_KEYIN_MAJOR_LOSS, listDataLossMajor),
        post(SAVE_DT_KEYIN_MINOR_LOSS, listDataLossMinor),
      ]);

      if (res1.resultCode != 200) {
        dispatch(messageAction.showMessage(res1.resultDescription));
      } else if (res2.resultCode != 200) {
        dispatch(messageAction.showMessage(res2.resultDescription));
      } else if (res3.resultCode != 200) {
        dispatch(messageAction.showMessage(res3.resultDescription));
      } else {
        dispatch(messageAction.showMessage("Save success."));
        fetchData();
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const fetchData = async () => {
    dispatch(loadingAction.showLoading());

    try {
      let [ListPerformance, ListLossMajor, ListLossMinor] = generateRow();
      // console.log(ListPerformance,ListLossMajor,ListLossMinor)
      // console.log(ListPerformance)
      //   setlistDataGasDeliveryPlan();

      let [res1, res2, res3] = await Promise.all([
        post(GET_DT_PERFORMANCE, {
          PERFORMANCE_YEAR: moment(new Date(yearSelected.value, 0, 1)).format(
            "YYYY"
          ),
        }),
        post(GET_DT_KEYIN_MAJOR_LOSS, {
          MAJORLOSS_YEAR: moment(new Date(yearSelected.value, 0, 1)).format(
            "YYYY-MM-DD"
          ),
        }),
        post(GET_DT_KEYIN_MINOR_LOSS, {
          MINORLOSS_YEAR: moment(new Date(yearSelected.value, 0, 1)).format(
            "YYYY-MM-DD"
          ),
        }),
      ]);

      setModelDeviceList(ListPerformance.map(row => {
        let performanceData = res1.data.dtKeyinPerformanceList.find(obj => moment(obj.PERFORMANCE_YEAR).format("YYYY-MM-DD") == row.PERFORMANCE_YEAR)
        return { ...row, ...performanceData }
      }));

      setListDataLossMajor(ListLossMajor.map(row => {
        let majorData = res2.data.dtKeyinMajorLossList.find(obj => moment(obj.MAJORLOSS_DATE).format("YYYY-MM-DD") == row.MAJORLOSS_DATE && obj.MAJORLOSS_MONTH == row.MAJORLOSS_MONTH)
        return { ...row, ...majorData }
      }));
      setListDataLossMinor(ListLossMinor.map(row => {
        let minorData = res3.data.dtKeyinMinorLossList.find(obj => moment(obj.MINORLOSS_DATE).format("YYYY-MM-DD") == row.MINORLOSS_DATE && obj.MINORLOSS_MONTH == row.MINORLOSS_MONTH)
        return { ...row, ...minorData }
      }));
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  // const fetchData = async () => {
  //   dispatch(loadingAction.showLoading());
  //   try {
  //     let res = await post(GET_DT_PERFORMANCE, {});
  //     setDataList(res.data.dtKeyinPerformanceList);
  //   } catch (error) {
  //     dispatch(messageAction.showMessage(error.message));
  //   }
  //   dispatch(loadingAction.hideLoading());
  // };

  // useEffect(() => {
  //   generateRow();
  // }, [dataList]);

  // useEffect(() => {
  //   addHeaderTable();
  //   addHeaderTableLossMinor();
  //   addHeaderTableLossMajor();
  //   fetchData();
  // }, []);

  useEffect(() => {
    addHeaderTable();
    addHeaderTableLossMajor();
    addHeaderTableLossMinor();
  }, []);

  useEffect(() => {
    fetchData();
  }, [yearSelected.value]);

  const addFieldToModelDeviceList = rowList => {
    let dataModel = {
      PID: "",
      PERFORMANCE_YEAR: "",
      // PERFORMANCE_MAJOR: 0,
      // PERFORMANCE_MINOR: 0,
      PERFORMANCE_MAJORGAS: 0,
      PERFORMANCE_MAJORTSO: 0,
      PERFORMANCE_MINORGAS: 0,
      PERFORMANCE_MINORTSO: 0,
      PRIORITY_FLAG: 0,
      STATUS_FLAG: 0,
    };
    let data = dataList;
    let modelList = [];
    modelList = [...rowList.map(obj => {
      let value = data.find(
        value =>
          moment(value.PERFORMANCE_YEAR).format("YYYY") ==
          moment(obj.PERFORMANCE_YEAR).format("YYYY")
      );
      return { ...dataModel, ...obj, ...value }
    })];
    return modelList;
  };
  return (
    <div>
      <FormGroup className="row mb-3 mt-2">
            <Col
              sm={1}
              className="d-flex align-items-center justify-content-end"
            >
              <h5 style={{whiteSpace:"nowrap"}}> Data Year :</h5>
            </Col>
            <Col sm={3} className="align-items-center justify-content-start">
              <Select
                placeholder="Select Year"
                value={yearSelected}
                onChange={handleSelectedYear}
                options={listYear}
                classNamePrefix="select2-selection"
              />
            </Col>
        
          <Col
              sm={8}
              className=" d-flex align-items-center justify-content-end"
            >
      {/* <div className="d-flex justify-content-end"> */}
        {permission.eOTH && (
          <button
            type="button"
            className="btn btn-success me-2"
            onClick={handleSaveData}
          >
            <i className="bx bx-save"></i>&nbsp; Save
          </button>
        )}
         </Col>
            </FormGroup>
      {/* </div> */}
      <div className="mt-2">
        <BootstrapTable
          id="performance-tab-table"
          keyField="month"
          data={modelDeviceList}
          columns={columnsPerformance}
          rowStyle={rowStyleFontWhite}
          headerClasses="header-style"
          cellEdit={cellEditFactory({
            mode: "click",
            blurToSave: true,
            onStartEdit: (oldValue, newValue, row, column) => {
              $("#performance-tab-table .form-control.editor.edit-text").bind(
                "enterKey",
                function (e) {
                  let cell = $(this).parent().next();
                  setTimeout(() => {
                    cell.click();
                  }, 50);
                }
              );
              $(
                "#performance-tab-table .form-control.editor.edit-text"
              ).keypress(function (e) {
                if (e.keyCode == 13) {
                  $(this).trigger("enterKey");
                }
              });
            },
          })}
        />
      </div>
      <div className="row">
        <Col sm="6">
          <div>
            <BootstrapTable
              id="loss-major-tab-table"
              keyField="month"
              wrapperClasses="table-on-scroll"
              data={listDataLossMajor}
              rowStyle={rowStyleFontWhite}
              columns={columnsGasLossMajor}
              headerClasses="header-style"
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
              })}
            />
          </div>
        </Col>
        <Col sm="6">
          <div>
            <BootstrapTable
              id="loss-minor-tab-table"
              keyField="month"
              wrapperClasses="table-on-scroll"
              data={listDataLossMinor}
              rowStyle={rowStyleFontWhite}
              columns={columnsGasLossMinor}
              headerClasses="header-style"
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
              })}
            />
          </div>
        </Col>
      </div>
    </div>
  );
}
export default Performance;

const columnsPerformance = [
  {
    dataField: "month",
    text: "Month",
    headerAlign: "center",
    editable: false,
    align: "center",

    headerStyle: {
      width: "5%",
      fontSize: "12px"
    },
    type: "number",
  },

  // {
  //   dataField: "PERFORMANCE_MAJOR",
  //   text: "รายใหญ่",
  //   headerAlign: "center",
  //   editable: true,
  //   align: "center",
  //   headerStyle: {
  //     width: "10%",
  //     fontSize: "12px",
  //   },
  //   editorStyle: ()=> {
  //     return {height:"25px"}
  //   },
  //   validator: (newValue, row, column, done) => {
  //     setTimeout(() => {
  //       if (isNaN(newValue)) {
  //         return done({
  //           valid: false,
  //           message: "Should be numeric",
  //         });
  //       }
  //       return done();
  //     }, 0);
  //     return {
  //       async: true,
  //     };
  //   },
  // },
  {
    dataField: "PERFORMANCE_MAJORGAS",
    text: "Gas Control ( รายใหญ่ )",
    headerAlign: "center",
    editable: true,
    align: "center",
    formatter: formatPercentNumber,
    headerStyle: {
      width: "10%",
      fontSize: "12px",
    },
    style: {
      cursor: "pointer"
    },
    editorStyle: () => {
      return { height: "25px" }
    },
    validator: (newValue, row, column, done) => {
      setTimeout(() => {
        if (isNaN(newValue)) {
          return done({
            valid: false,
            message: "Should be numeric",
          });
        }
        return done();
      }, 0);
      return {
        async: true,
      };
    },
  },
  {
    dataField: "PERFORMANCE_MAJORTSO",
    text: "TSO ( รายใหญ่ )",
    headerAlign: "center",
    editable: true,
    align: "center",
    formatter: formatPercentNumber,
    headerStyle: {
      width: "10%",
      fontSize: "12px",
    },
    style: {
      cursor: "pointer"
    },
    editorStyle: () => {
      return { height: "25px" }
    },
    validator: (newValue, row, column, done) => {
      setTimeout(() => {
        if (isNaN(newValue)) {
          return done({
            valid: false,
            message: "Should be numeric",
          });
        }
        return done();
      }, 0);
      return {
        async: true,
      };
    },
  },
  // {
  //   dataField: "PERFORMANCE_MINOR",
  //   text: "รายย่อย",
  //   headerAlign: "center",
  //   editable: true,
  //   align: "center",
  //   headerStyle: {
  //     width: "10%",
  //     fontSize:"12px"
  //   },
  //   editorStyle: ()=> {
  //     return {height:"25px"}
  //   },
  //   validator: (newValue, row, column, done) => {
  //     setTimeout(() => {
  //       if (isNaN(newValue)) {
  //         return done({
  //           valid: false,
  //           message: "Should be numeric",
  //         });
  //       }
  //       return done();
  //     }, 0);
  //     return {
  //       async: true,
  //     };
  //   },
  // },
  {
    dataField: "PERFORMANCE_MINORGAS",
    text: "Gas Control ( รายย่อย )",
    headerAlign: "center",
    editable: true,
    align: "center",
    formatter: formatPercentNumber,
    headerStyle: {
      width: "10%",
      fontSize: "12px"
    },
    style: {
      cursor: "pointer"
    },
    editorStyle: () => {
      return { height: "25px" }
    },
    validator: (newValue, row, column, done) => {
      setTimeout(() => {
        if (isNaN(newValue)) {
          return done({
            valid: false,
            message: "Should be numeric",
          });
        }
        return done();
      }, 0);
      return {
        async: true,
      };
    },
  },
  {
    dataField: "PERFORMANCE_MINORTSO",
    text: "TSO ( รายย่อย )",
    headerAlign: "center",
    editable: true,
    align: "center",
    formatter: formatPercentNumber,
    headerStyle: {
      width: "10%",
      fontSize: "12px"
    },
    style: {
      cursor: "pointer"
    },
    editorStyle: () => {
      return { height: "25px" }
    },
    validator: (newValue, row, column, done) => {
      setTimeout(() => {
        if (isNaN(newValue)) {
          return done({
            valid: false,
            message: "Should be numeric",
          });
        }
        return done();
      }, 0);
      return {
        async: true,
      };
    },
  },
];

const performanceModel = {
  PID: "",
  PERFORMANCE_YEAR: "",
  // PERFORMANCE_MAJOR: 0,
  // PERFORMANCE_MINOR: 0,
  PERFORMANCE_MAJORGAS: 0,
  PERFORMANCE_MAJORTSO: 0,
  PERFORMANCE_MINORGAS: 0,
  PERFORMANCE_MINORTSO: 0,
  PRIORITY_FLAG: 0,
  STATUS_FLAG: 0,
}

const columnsGasLossMajor = [
  {
    dataField: "MAJORLOSS_MONTH",
    text: "Month",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#7e8eda",
      width: "20%",
      fontSize: "12px",
    },
  },
  {
    dataField: "MAJORLOSS_DATAGAS",
    text: "Gas Control",
    headerAlign: "center",
    editable: true,
    align: "center",
    formatter: formatNumber,
    headerStyle: {
      backgroundColor: "#6478D7",
      width: "20%",
      fontSize: "12px",
    },
    style: {
      cursor: "pointer"
    },
    editorStyle: () => {
      return { height: "25px" }
    },
    validator: (newValue, row, column, done) => {
      setTimeout(() => {
        if (isNaN(newValue)) {
          return done({
            valid: false,
            message: "Should be numeric",
          });
        }
        return done();
      }, 0);
      return {
        async: true,
      };
    },
  },
  {
    dataField: "MAJORLOSS_DATATSO",
    text: "TSO",
    headerAlign: "center",
    editable: true,
    align: "center",
    formatter: formatNumber,
    headerStyle: {
      backgroundColor: "#6478D7",
      width: "20%",
      fontSize: "12px",
    },
    style: {
      cursor: "pointer"
    },
    editorStyle: () => {
      return { height: "25px" }
    },
    validator: (newValue, row, column, done) => {
      setTimeout(() => {
        if (isNaN(newValue)) {
          return done({
            valid: false,
            message: "Should be numeric",
          });
        }
        return done();
      }, 0);
      return {
        async: true,
      };
    },
  },
];
const lossMajorModel = {
  PID: "",
  MAJORLOSS_DATE: "",
  MAJORLOSS_MONTH: 0,
  MAJORLOSS_DATAGAS: 0,
  MAJORLOSS_DATATSO: 0,
  // MAJORLOSS_DATA: 0,
};

const columnsGasLossMinor = [
  {
    dataField: "MINORLOSS_MONTH",
    text: "Month",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#7e8eda",
      width: "20%",
      fontSize: "12px",
    },
  },
  {
    dataField: "MINORLOSS_DATAGAS",
    text: "Gas Control",
    headerAlign: "center",
    editable: true,
    align: "center",
    formatter: formatNumber,
    headerStyle: {
      backgroundColor: "#6478D7",
      width: "20%",
      fontSize: "12px",
    },
    style: {
      cursor: "pointer"
    },
    editorStyle: () => {
      return { height: "25px" }
    },
    validator: (newValue, row, column, done) => {
      setTimeout(() => {
        if (isNaN(newValue)) {
          return done({
            valid: false,
            message: "Should be numeric",
          });
        }
        return done();
      }, 0);
      return {
        async: true,
      };
    },
  },
  {
    dataField: "MINORLOSS_DATATSO",
    text: "TSO",
    headerAlign: "center",
    editable: true,
    align: "center",
    formatter: formatNumber,
    headerStyle: {
      backgroundColor: "#6478D7",
      width: "20%",
      fontSize: "12px",
    },
    style: {
      cursor: "pointer"
    },
    editorStyle: () => {
      return { height: "25px" }
    },
    validator: (newValue, row, column, done) => {
      setTimeout(() => {
        if (isNaN(newValue)) {
          return done({
            valid: false,
            message: "Should be numeric",
          });
        }
        return done();
      }, 0);
      return {
        async: true,
      };
    },
  },
];
const lossMinorModel = {
  PID: "",
  MINORLOSS_DATE: "",
  MINORLOSS_MONTH: 0,
  MINORLOSS_DATAGAS: 0,
  MINORLOSS_DATATSO: 0,
  // MINORLOSS_DATA: 0,
};

Performance.propTypes = {
  yearSelected: PropTypes.any,
};
